import { API_SUCCESS, API_ERROR } from "./api";

export const SEND_FEEDBACK = "SEND_FEEDBACK";
export const FETCH_FEEDBACKS = "FETCH_FEEDBACKS";

export const sendFeedback = ({ feedback }) => ({
  type: SEND_FEEDBACK,
  payload: { feedback },
});

export const fetchFeedbacksRequest = ({ page = 1, limit = 20 } = {}) => ({
  type: FETCH_FEEDBACKS,
  payload: { page, limit },
});

const defaultPagination = {
  page: 1,
  limit: 20,
  total: 0,
  total_pages: 0,
};

const initialState = {
  list: [],
  pagination: defaultPagination,
  error: null,
};

export default function feedbackReducer(state = initialState, action) {
  if (action.type === `${FETCH_FEEDBACKS} ${API_SUCCESS}`) {
    const payload = action.payload;
    const response = payload?.response ?? payload;
    const data = response?.data;
    const list = Array.isArray(data) ? data : [];
    const pagination = response?.pagination
      ? {
          page: response.pagination.page ?? state.pagination.page,
          limit: response.pagination.limit ?? state.pagination.limit,
          total: response.pagination.total ?? 0,
          total_pages: response.pagination.total_pages ?? 0,
        }
      : state.pagination;
    return {
      ...state,
      list,
      pagination,
      error: null,
    };
  }
  if (action.type === `${FETCH_FEEDBACKS} ${API_ERROR}`) {
    const err = action.payload;
    const message =
      err?.response?.data?.message ??
      err?.message ??
      err?.error ??
      "Failed to load feedbacks";
    return {
      ...state,
      error: message,
    };
  }
  return state;
}

export const selectFeedbacksList = (state) => state.feedback?.list ?? [];
export const selectFeedbacksPagination = (state) =>
  state.feedback?.pagination ?? defaultPagination;
export const selectFeedbacksError = (state) => state.feedback?.error ?? null;
